import CurrentCastRelationshipSection from './CurrentCastRelationshipSection';
import MaterialIconSwipeAnimation from './MaterialIconSwipeAnimation';
import type { components } from '@pocapan/shared/types/schema';
import type { ScenePersona } from '../types';

type CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface AddSceneArtistsBoxProps {
  firstPersona: ScenePersona | null;
  secondPersona: ScenePersona | null;
  onAddSceneArtist: (slot: 'first' | 'second') => void;
}

const AddSceneArtistsBox = ({
  firstPersona,
  secondPersona,
  onAddSceneArtist
}: AddSceneArtistsBoxProps) => {
  const castRelationship: Pick<CastRelationship, 'personA' | 'personB'> = {
    personA: {
      name: firstPersona?.nickname ?? null,
      thumbnailUrl: firstPersona?.dataUrl ?? null,
      role: 'person_a',
      configured: Boolean(firstPersona)
    },
    personB: {
      name: secondPersona?.nickname ?? null,
      thumbnailUrl: secondPersona?.dataUrl ?? null,
      role: 'person_b',
      configured: Boolean(secondPersona)
    }
  };

  return (
    <div className="mt-[34px]">
      <CurrentCastRelationshipSection
        currentCastRelationship={castRelationship as CastRelationship}
        gap={25}
        onPersonAClick={() => onAddSceneArtist('first')}
        onPersonBClick={() => onAddSceneArtist('second')}
        showCameraIcon={true}
      >
        <MaterialIconSwipeAnimation />
      </CurrentCastRelationshipSection>
    </div>
  );
};

export default AddSceneArtistsBox;
